import { isObject } from './is-object'

interface IObject {
  [key: string]: any
}

interface IDeepMerge {
  <T = IObject>(target: IObject, ...sources: Array<IObject>): T
}

/**
 * @description Method to perform a deep merge of objects
 * @param {Object} target - The targeted object that needs to be merged with the supplied @sources
 * @param {Array<Object>} sources - The source(s) that will be used to update the @target object
 * @return {Object} The final merged object
 */
export const deepMerge: IDeepMerge = <T>(
  target: IObject,
  ...sources: Array<IObject>
): T => {
  if (!sources.length) {
    return target as T
  }

  const result: IObject = target

  if (isObject(result)) {
    for (const element of sources) {
      if (isObject(element)) {
        for (const key in element) {
          if (element[key]) {
            if (isObject(element[key])) {
              if (!result[key] || !isObject(result[key])) {
                result[key] = {}
              }
              deepMerge(result[key], element[key])
            } else {
              if (Array.isArray(result[key]) && Array.isArray(element[key])) {
                result[key] = Array.from(
                  new Set(result[key].concat(element[key]))
                )
              } else {
                result[key] = element[key]
              }
            }
          }
        }
      }
    }
  }

  return result as T
}
